import React, { useState } from 'react';
import './navbar.css';
import {header} from "../../data";

// import '../LandingPage/LandingPage.css';
import { BrowserRouter as Router,Link } from 'react-router-dom';

function App() {

    const [style, setStyle] = useState({ 'display' : 'none', 'width': '0%', zIndex: 0});

    // const [display, setDisplay] = useState({'style': { 'display' : 'flex', 'width': '100%', zIndex: 1  }});

    const handleClick = () => {
        setStyle(
            { 'display' : 'flex', 'width': '100%', 'marginTop': '0px', zIndex: 3}
        );
        // setDisplay({ 'style': { 'display' : 'flex', 'width': '100%', zIndex: 0 }});
    }

    let CloseNav = () => {
        setStyle({ "display": 'none', 'width': '0%', zIndex: 0});
        // setDisplay({ 'style': { 'display' : 'flex', 'width': '100%', zIndex: 1 }});
        console.log("testing");
    }
  return (
        <>
           
                <Frame144 group86Props={frame144Data.group86Props} iconMenuProps={frame144Data.iconMenuProps} handleClick = {handleClick}/>
           
            <div className = "nav-overlay" style = { style }>
                <div className="nav-group-213">
                    <div className="nav-flex-col">
                        <Group86
                        group85="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/group-85-47@2x.svg"
                        whiteProps={group86Data.whiteProps}
                        />
                        <Frame27 {...frame27Data} />
                    </div>
                    <Carbonclose src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/vector-300@2x.svg" handleClick={ CloseNav } style = {{cursor: "pointer"}} />
                </div>
            </div>
        </>
  );
}

export default App;

function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="nav-group-86">
      <White src={whiteProps.src} />
      <img className="nav-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="nav-white">
      {/* <img className="nav-vector" src={} /> */}
    </div>
  );
}


function Frame27(props) {
  const {
    unselected,
    unselected2,
    unselected3,
    unselected4,
    unselected5,
    unselected6,
    unselected7,
    unselected8,
  } = props;

  return (
    <div className="nav-frame-27">
      <Link to="/">
      <div className="nav-unselected lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected}</div>
      </Link>
      <Link to="/about">
      <div className="nav-unselected-1 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected2}</div>
      </Link>
      <Router forceRefresh={true}>
      <Link to="/packagedetails/1/1">
      <div className="nav-unselected-1 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">PACKAGES</div>
      </Link>
      </Router>
      <Link to="/project">
      <div className="nav-unselected-2 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected3}</div>
      </Link>
      <Link to="/video">
      <div className="nav-unselected-3 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected4}</div>
      </Link>
      <Link to="/insight">
      <div className="nav-unselected-4 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected5}</div>
      </Link>
      <Link to="/blog">
      <div className="nav-unselected-5 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected6}</div>
      </Link>
      <Link to="/faq">
      <div className="nav-unselected-6 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected7}</div>
      </Link>
      <Link to="/contactus">
      <div className="nav-unselected-7 lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{unselected8}</div>
      </Link>
    </div>
  );
}


function Carbonclose(props) {
  const { src, handleClick } = props;

  return (
    <div className="nav-carbonclose" onClick = { handleClick }>
      <img className="nav-vector-1" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/vector-432@2x.svg",
};

const group86Data = {
    whiteProps: whiteData,
};

const frame27Data = {
    unselected: "HOME",
    unselected2: "ABOUT US",
    unselected3: "PROJECTS",
    unselected4: "VIDEOS",
    unselected5: "INSIGHTS",
    unselected6: "BLOGS",
    unselected7: "FAQ’S",
    unselected8: "CONTACT US",
};

function IconMenu(props) {

    const { vector2, vector3, handleClick } = props;
  
    return (
      <div className="lpt-icon-menu" onClick={ handleClick }>
        <img
          className="lpt-vector-2"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
        />
        <img className="lpt-vector-1" src={vector2} />
        <img className="lpt-vector-1" src={vector3} />
      </div>
    );
  }

  
function Group86(props) {
    const { group85, whiteProps } = props;
  
    return (
      <Link to="/home">
      <div className="lpt-group-86">
        <White src={whiteProps.src} />
        {/* <img className="lpt-group-85" src="https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg" /> */}
        <img className="lpt-group-85" src={header.WebuilddHeaderIcon}/>
      </div>
      </Link>
    );
  }

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};


function Frame144(props) {
    const { group86Props, iconMenuProps, handleClick } = props;
  
    return (
      <div className="lpt-frame-144">
        <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
        <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} handleClick={handleClick}/>
      </div>
    );
  }
